import * as React from "react";
// calls ihazip
import * as axios from "axios";
import { useAppSelector } from "../../../store/hooks";
import { Button, Card } from "antd";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { v4 as uuidv4 } from "uuid";
import { sentryLog } from "../../../tools/sentry";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { cloneDeep } from "lodash";
import { CpArrayObject } from "../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemFirewallRule } from "./CpArrayItemFirewallRule";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {}
export const Firewall: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const userName = useAppSelector((state) => state.user.name);

  const firewallRules = useCpFormValue(`firewall`);
  const allowAllCIDR = `0.0.0.0/0`;

  const [myIp, setMyIp] = React.useState<string>(null as any);

  const allowsAll = React.useMemo(() => {
    return firewallRules.some((fr) => fr.sourceCIDR === allowAllCIDR);
  }, [firewallRules]);
  const allowsMyIp = React.useMemo(() => {
    return firewallRules.some((fr) => fr.sourceCIDR === myIp);
  }, [firewallRules]);
  const isDefaults = React.useMemo(() => {
    return firewallRules.length === 1 && firewallRules[0].sourceCIDR === allowAllCIDR;
  }, [firewallRules]);

  async function toggleMyIp(): Promise<void> {
    if (!myIp) {
      return;
    }

    if (allowsAll) {
      return;
    }

    const index = firewallRules.findIndex((fr) => fr.sourceCIDR === myIp);
    const _firewall = cloneDeep(firewallRules);
    if (index >= 0) {
      _firewall.splice(index, 1);
      formSetValue(id, `firewall`, _firewall);
    } else {
      _firewall.push({
        id: uuidv4(),
        sourceCIDR: myIp,
        description: `${userName}'s IP`,
      });
    }
  }

  React.useEffect(() => {
    populateIp();
  }, []);

  async function populateIp() {
    let ip = "";
    try {
      const { data: ipRes } = await axios.default.get("https://ipv4.icanhazip.com/");
      ip = ipRes.trim();
      if (!ip.endsWith(`/32`) && !ip.includes(`/`)) {
        ip += `/32`;
      }
      setMyIp(ip);
    } catch (e) {
      sentryLog(`mk8s firewall myip failed`, { "data.error": e.message });
      return;
    }
  }

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className="flex items-baseline gap-2">
              <div className="mr-4">Firewall Rules</div>
              {isDefaults ? null : (
                <Button
                  size={"small"}
                  onClick={() => {
                    formSetValue(id, `firewall`, [
                      { id: uuidv4(), sourceCIDR: allowAllCIDR, description: "Default allow-all rule" },
                    ]);
                  }}
                  type={"default"}
                >
                  Set Defaults
                </Button>
              )}
              {!myIp || allowsAll ? null : (
                <Button size={"small"} onClick={toggleMyIp} type={"default"}>
                  {allowsMyIp ? "Remove " : "Add "}My IP
                </Button>
              )}
            </div>
          </CardTitle>
          <CardContent>
            <div style={{ maxWidth: 900 }}>
              <CpArrayObject
                name="firewall"
                factoryFn={() => ({ id: uuidv4(), sourceCIDR: "", description: "" })}
                labels={["Source CIDR", "Description"]}
              >
                <CpArrayItemFirewallRule />
              </CpArrayObject>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
